import { useContext } from "react";

import { ParentContext } from "./ParentContextProvider";

export default function useParentContext() {
  const context = useContext(ParentContext);
  if (context) return context;

  const errorMessage = `useParentContext must be used within a ParentContextProvider`;
  throw new Error(errorMessage);
}
